import React from 'react';
import ReportingSalesBySourcePage from '../components/ReportingSalesBySourcePage';

const ReportingSalesBySourceApp = (props) => (
  <ReportingSalesBySourcePage {...props} />
);

export default ReportingSalesBySourceApp;
